import React from 'react';

function UVAManuscripts() {
    const scrollToSection = (ref) => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div>
            <div id="top">
                <h1 className="head">University of Virginia Manuscript Reproductions</h1>
            </div>

            <p className="first">
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms3').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >
                    &bull; Manuscript #3: AMs [1783?], poem about Columbus [mutilated glossy photopraph].<br />

                </button>
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms4').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #4: AMs [glossy photograph only, mutilated], with pencil note on verso, "Sample of Liberty of Conscience 1783."</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms5').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #5: AMs [glossy photograph only], 1786 May 11, page with notes and memoranda at top, and "Poems on several Occasions by Charles Brown of Philadelphia" below.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms6').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #6: AMs [glossy photograph only, mutilated], [1786] page with poems, one signed "By [mutilated] at 15 years old, his first Essay on some of his School fellows, members of the Philological Society."</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms7').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #7: AMs [glossy photograph only], 1787, poem "By Charles Brown -- aged 16 years, the first part on himself -- under the signature of Aretas and several of their Society under the Signatures of ..."</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms21').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #21: AMs [glossy photograph], 1801 March 9[?] Miscellaneous notes; commentary on Jefferson's marginal address; note of an earthquake in Salem, Mass.; and a poem.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms22').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #22: AMs [glossy photograph only], 1801 October 12[?], two notebook pages -- the left page headed "Index" and the right page with the words "nakedness, nudity."</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms23').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #23: AMs [glossy photograph only, mutilated], [ca. 1801], two notebook pages numbered 32 and 33 bearing miscellaneous notes and poetry.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms29').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #29: Receipt, 1806 November 11, for Brown's subscription to Dr. Ree's New Cyclopedia.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms64').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #64: Five AMs [glossy photographs only], notes for <u>Weiland</u>, miscellaneous notes, dialogues, etc.  The last page is inscribed "Elihu Hubbard Smith."  These are probably pages from the same notebook; they are numbered 5, 6; 7, 8; 10, 11; 24, 25; and 78, 79.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms68').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #68: AMs [glossy photograph only] n.d., of notes for a novel, the scene Europe and America, the period 1766-1768.</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms69').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #69: AMs [photostat only] n.d., beginning "Will this be sufficient by way of exercise?"</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms70').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #70: AMs [glossy photograph only] n.d., two pages of a notebook beginning, "With great courage and elevation of sentiment he told the court that the pretended crime..."</button><br />
                <button
                    className="link-button"
                    onClick={() => document.getElementById('ms76').scrollIntoView({ behavior: 'smooth' })}
                    style={{ cursor: 'pointer' }}
                >&bull; Manuscript #76: AM [glossy photograph only, mutilated] n.d., headed "[mutilated] a Poem."</button><br />
            </p>
            <p className="first" align="center"><b>The Reproductions</b></p>


            <section id="ms3">
                <p class="first" align="center">Manuscript #3: AMs [1783?], poem about Columbus [mutilated glossy photopraph].</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-3_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-3_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-3_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-3_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                    </tr>
                </table>
                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>

            </section>
            <section id="ms4">
                <p class="first" align="center">Manuscript #4: AMs [glossy photograph only, mutilated], with pencil note on verso, "Sample of Liberty of Conscience 1783."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-4_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-4_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-4_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-4_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>
                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>

            <section id="ms5"><p class="first" align="center">Manuscript #5: AMs [glossy photograph only], 1786 May 11, page with notes and memoranda at top, and "Poems on several Occasions by Charles Brown of Philadelphia" below.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-5.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-5_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms6">
                <p class="first" align="center">Manuscript #6: AMs [glossy photograph only, mutilated], [1786] page with poems, one signed "By [mutilated] at 15 years old, his first Essay on some of his School fellows, members of the Philological Society."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-6_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-6_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-6_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-6_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms7">
                <p class="first" align="center">Manuscript #7: AMs [glossy photograph only], 1787, poem "By Charles Brown -- aged 16 years, the first part on himself -- under the signature of Aretas and several of their Society under the Signatures of ..."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-7_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-7_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-7_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-7_2_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-7_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-7_3_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>
                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms21">
                <p class="first" align="center">Manuscript #21: AMs [glossy photograph], 1801 March 9[?] Miscellaneous notes; commentary on Jefferson's marginal address; note of an earthquake in Salem, Mass.; and a poem.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-21_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-21_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-21_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-21_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>

            </section>
            <section id="ms22">
                <p class="first" align="center">Manuscript #22: AMs [glossy photograph only], 1801 October 12[?], two notebook pages -- the left page headed "Index" and the right page with the words "nakedness, nudity."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-22_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-22_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-22_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-22_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms23">


                <p class="first" align="center">Manuscript #23: AMs [glossy photograph only, mutilated], [ca. 1801], two notebook pages numbered 32 and 33 bearing miscellaneous notes and poetry.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-23_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-23_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-23_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-23_2_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-23_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-23_3_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms29">



                <p class="first" align="center">Manuscript #29: Receipt, 1806 November 11, for Brown's subscription to Dr. Ree's New Cyclopedia.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-29.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-29_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms64">
                <p class="first" align="center">Manuscript #64: Five AMs [glossy photographs only], notes for <u>Weiland</u>, miscellaneous notes, dialogues, etc.  The last page is inscribed "Elihu Hubbard Smith."  These are probably pages from the same notebook; they are numbered 5, 6; 7, 8; 10, 11; 24, 25; and 78, 79.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_2_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_3_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1 [p. 24.1]</p></td>
                        <td><p class="caption" align="center">Transcription, page 2 [p. 24.2]</p></td>
                        <td><p class="caption" align="center">Transcription, page 3 [p. 24.3]</p></td>
                    </tr>
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_4.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_4_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_5.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_5_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_6.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-64_6_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 4 [p. 24.4]</p></td>
                        <td><p class="caption" align="center">Transcription, page 5 [p. 4]</p></td>
                        <td><p class="caption" align="center">Transcription, page 6 [p. 5]</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>

            </section>
            <section id="ms68">
                <p class="first" align="center">Manuscript #68: AMs [glossy photograph only] n.d., of notes for a novel, the scene Europe and America, the period 1766-1768.</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-68_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-68_2_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                    </tr>
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-64_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-68_3_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-68_4.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-68_4_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 3</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>


            </section>
            <section id="ms69">
                <p class="first" align="center">Manuscript #69: AMs [photostat only] n.d., beginning "Will this be sufficient by way of exercise?"</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-69.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-69_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>

            </section>
            <section id="ms70">

                <p class="first" align="center">Manuscript #70: AMs [glossy photograph only] n.d., two pages of a notebook beginning, "With great courage and elevation of sentiment he told the court that the pretended crime..."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-70_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-70_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-70_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-70_2_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-70_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-70_3_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
            <section id="ms76">

                <p class="first" align="center">Manuscript #76: AM [glossy photograph only, mutilated] n.d., headed "[mutilated] a Poem."</p>
                <table align="center" border="0" cellspacing="10" cellpadding="0">
                    <tr>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_1.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_1_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_2.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_2_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_3.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_3_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 1</p></td>
                        <td><p class="caption" align="center">Transcription, page 2</p></td>
                        <td><p class="caption" align="center">Transcription, page 3</p></td>
                    </tr>
                    <tr>

                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_4.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_4_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_5.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_5_thumb.jpg`} alt="Manuscript" /></a></td>
                        <td align="center"><a href={`${process.env.PUBLIC_URL}/images/scans/UVA/MS-76_6.jpg`} target="_blank" rel="noreferrer noopener"><img src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/MS-76_6_thumb.jpg`} alt="Manuscript" /></a></td>                    </tr>
                    <tr>
                        <td><p class="caption" align="center">Transcription, page 4</p></td>
                        <td><p class="caption" align="center">Transcription, page 5</p></td>
                        <td><p class="caption" align="center">Photocopy</p></td>
                    </tr>
                </table>

                <p align="right">
                    Return to <button
                        className="link-button"
                        onClick={() => scrollToSection({ current: document.getElementById('top') })}
                        style={{ cursor: 'pointer' }}
                    >
                        top
                    </button>
                </p>
            </section>
        </div>
    );
}

export default UVAManuscripts;
